import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { Gauge } from 'lucide-react';
import { usePrincipal } from '../auth/AuthBoundary';
import './bell.css';

/**
 * The admin area in plain sight for Ademero staff: a mark in the bar beside the person, so nobody
 * opens the profile menu to find it (Dustin, 2026-10-07). The same condition as the menu's Admin
 * row, the API's staff claim, and nothing at all for a customer. Inside a company under a support
 * grant it still leads to the admin area. Under 480 px the word gives way and the mark is round
 * like its neighbours; the name is said either way.
 */
export function AdminMark(): ReactNode {
  const principal = usePrincipal();
  if (!principal.staff) return null;
  return (
    <Link
      to="/admin"
      search={{}}
      className="company-mark admin-mark"
      aria-label="Admin area"
      title="Admin area"
    >
      <Gauge size={17} aria-hidden="true" />
      <span className="admin-mark__word">Admin</span>
    </Link>
  );
}
